export type FormattedOrder = {
  hasValue: boolean;
  className: string;
  badgeClass: string;
  quantityDisplay: string;
  price: number | null;
  traderDisplay: string;
};

export const formatOrder = (
  price: number | null,
  quantity: number | null,
  traderCode: string | null,
  type: "bid" | "ask",
): FormattedOrder => {
  const className = type === "bid" ? "market-side bid" : "market-side ask";
  const badgeClass = type === "bid" ? "badge--bid" : "badge--ask";

  if (price == null || quantity == null) {
    return {
      hasValue: false,
      className,
      badgeClass,
      quantityDisplay: "—",
      price: null,
      traderDisplay: "—",
    };
  }

  const qtyDisplay =
    quantity % 1 === 0 ? `${quantity}` : quantity.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
  const traderDisplay = traderCode ? traderCode.toUpperCase() : "ANON";

  return {
    hasValue: true,
    className,
    badgeClass,
    quantityDisplay: qtyDisplay,
    price,
    traderDisplay,
  };
};

export type SpreadMetrics = {
  spread: number | null;
  mid: number | null;
};

export const computeSpread = (bid: number | null, ask: number | null): SpreadMetrics => {
  if (bid == null || ask == null) {
    return { spread: null, mid: null };
  }
  const spread = parseFloat((ask - bid).toFixed(2));
  const mid = parseFloat(((ask + bid) / 2).toFixed(2));
  return { spread, mid };
};

export const roundLabels: Record<string, string> = {
  ROUND_1: "Rd 1",
  ROUND_2: "Rd 2",
  SEMI_FINAL: "Semi",
  FINAL: "Final",
};
